<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 text-center">
      <div class="mb-4">
        <img
          [src]="
            (module.corporation$ | async)?.logoMedia?.url ||
            'assets/images/brands/tsolife-logo-200x45.svg'
          "
          height="80" />
      </div>
      <h4 class="mb-4">Congratulations On The New Move In!</h4>
      <a class="btn btn-primary fw-bold" [routerLink]="['wizard']">Start</a>
    </div>
  </div>
</div>
